import { Environment } from '../../../enums';

const API_VERSION = 'api/v1';

export const getApiBaseUrl = (environment: Environment): string => {
    if (environment === Environment.PROD) {
        return `https://chromecast.api.onvesper.com/${API_VERSION}`;
    }
    if (environment === Environment.STAGING) {
        return `https://chromecast.api.onvesper-staging.com/${API_VERSION}`;
    }
    if (environment === Environment.QA) {
        return `https://chromecast.api.onvesper-qa.com/${API_VERSION}`;
    }
    if (environment.startsWith('qa')) {
        return `https://chromecast.api-${environment}.onvesper-qa.com/${API_VERSION}`;
    }
    if (environment === Environment.DEV) {
        return `https://chromecast.api.onvesper-dev.com/${API_VERSION}`;
    }
    return `https://chromecast.api.onvesper.com/${API_VERSION}`;
};
